import { FC } from "react";
import { sanitizeHtml } from "@smile2impress/attraction-utils";
import {
    Box,
    Spacer,
    Heading,
    Text,
    Button,
    Grid,
    GridItem,
    useBreakpointValue,
    Picture,
} from "@smile2impress/components/relaunch";
import { useGoToBooking } from "hooks/useGoToBooking";

import Link from "components/Link";
import { Video } from "components/Video";

import { TextWithCTAProps } from "./TextWithCTA.types";

export const TextWithCTA: FC<TextWithCTAProps> = ({ content, headingAs }) => {
    const { title, text, cta, image, video } = content;
    const { goToBooking } = useGoToBooking();
    if (!cta.onClick && !cta.link) {
        cta.onClick = goToBooking;
    }
    const { text: buttonText, onClick, link } = cta;

    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
        desktopXL: false,
    });

    return (
        <Box as="section">
            <Grid
                templateColumns={[
                    null,
                    null,
                    `${13 / 24}fr ${2 / 24}fr ${14 / 24}fr`,
                ]}
                templateRows={[`auto auto auto`, null, null]}
            >
                <GridItem mb={[2, 2, 0]}>
                    <Heading
                        textStyle={["title1"]}
                        color={["text.base"]}
                        as={headingAs}
                        pl={[0, 0, 4]}
                    >
                        {title}
                    </Heading>
                    {isMobile && (
                        <>
                            {image && (
                                <Box
                                    borderRadius="sm"
                                    overflow="hidden"
                                    bgColor="base.grey"
                                    mt={[2, 2, 4]}
                                >
                                    <Picture {...image} />
                                </Box>
                            )}
                            {video && (
                                <Video
                                    h="auto"
                                    borderRadius="sm"
                                    mt={[2, 2, 4]}
                                    objectFit="cover"
                                    {...video}
                                />
                            )}
                        </>
                    )}
                </GridItem>
                <Spacer />
                <GridItem pr={[0, 0, 4]}>
                    <Box>
                        <Text
                            mb={[2]}
                            textStyle="body"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(text),
                            }}
                        />
                        <Button
                            as={Link}
                            {...(onClick ? { onClick } : {})}
                            {...(link ? { href: link } : {})}
                            width={["100%", "100%", "auto"]}
                        >
                            {buttonText}
                        </Button>
                    </Box>
                </GridItem>
            </Grid>
            {!isMobile && (
                <>
                    {image && (
                        <Box bgColor="base.grey" mt={[2, 2, 4]}>
                            <Picture {...image} />
                        </Box>
                    )}
                    {video && (
                        <Video
                            h="596px"
                            mt={[2, 2, 4]}
                            objectFit="cover"
                            {...video}
                        />
                    )}
                </>
            )}
        </Box>
    );
};
